import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable } from 'rxjs';
import { CreateAnnualLeaveEntitlement } from 'app/dtos/AnnualLeaveEntitlement/createAnnualLeaveEntitlement';
import { UpdateAnnualLeaveEntitlement } from 'app/dtos/AnnualLeaveEntitlement/updateAnnualLeaveEntitlement';

@Injectable({
  providedIn: 'root'
})
export class AnnualLeaveEntitlementService {

  constructor(private httpClientService: HttpClientService) { }

  async getAllAnnualLeaveEntitlement(page, size) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.AnnualLeaveEntitlement,
      queryString: `Page=${page}&size=${size}`
    });
    return await firstValueFrom(observable);
  }

  async getByIdPersonAllAnnualLeaveEntitlements(page, size, id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.AnnualLeaveEntitlement,
      queryString: `Page=${page}&size=${size}&id=${id}`,
      action: "GetByIdPersonAnnualLeaveEntitlementService"
    });
    return await firstValueFrom(observable);
  }

  async createAnnualLeaveEntitlement(createAnnualLeaveEntitlement: CreateAnnualLeaveEntitlement) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.AnnualLeaveEntitlement
    }, createAnnualLeaveEntitlement);
    return await firstValueFrom(observable);
  }

  async updateAnnualLeaveEntitlement(updateAnnualLeaveEntitlement: UpdateAnnualLeaveEntitlement) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.AnnualLeaveEntitlement
    }, updateAnnualLeaveEntitlement);
    return await firstValueFrom(observable);
  }

  async createAnnualLeaveEntitlementsForAllPersons() {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.AnnualLeaveEntitlement,
      action: "CreateAnnualLeaveEntitlementsForAllPersons"
    }, null);
    return await firstValueFrom(observable);
  }

  async getTheRemainingAnnualLeaveEntitlementOfTheStaff(isTotal,search)
  {
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.AnnualLeaveEntitlement,
      action:"GetTheRemainingAnnualLeaveEntitlementOfTheStaff",
      queryString:`isTotal=${isTotal}&search=${search}`
    });
    return await firstValueFrom(observable);
  }
}